export default "__VITE_ASSET__BWI4j$5l__"